import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "3rem",
  height: "3rem",
  viewBox: "0 0 48 48",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M22.3496 3.5L22.5752 3.50586C23.0988 3.53271 23.6075 3.65339 24.0986 3.86621C24.5841 4.07658 25.0178 4.35254 25.3955 4.69531L25.5537 4.84668L43.1533 22.4961C43.6014 22.9442 43.9347 23.456 44.1445 24.0283C44.3467 24.5797 44.4502 25.1379 44.4502 25.7002C44.4502 26.2628 44.3466 26.8146 44.1426 27.3525C43.9319 27.908 43.5985 28.4083 43.1533 28.8535L28.8535 43.1533C28.4082 43.5987 27.9018 43.9377 27.3359 44.1641C26.7816 44.3858 26.2186 44.4999 25.6504 44.5C25.082 44.5 24.5183 44.3859 23.9639 44.1641C23.398 43.9377 22.8916 43.5986 22.4463 43.1533L4.79688 25.5039C4.38336 25.0904 4.06279 24.6099 3.83789 24.0664C3.61231 23.5213 3.5 22.9472 3.5 22.3496V8C3.5 6.76634 3.94494 5.69764 4.82129 4.82129C5.69764 3.94494 6.76634 3.5 8 3.5H22.3496ZM8.5 22.0928L25.6504 39.292L39.2432 25.6992L22.0928 8.5H8.5V22.0928ZM13 9.5C13.9644 9.5 14.8003 9.84332 15.4785 10.5215C16.1567 11.1997 16.5 12.0356 16.5 13C16.5 13.9644 16.1567 14.8003 15.4785 15.4785C14.8003 16.1567 13.9644 16.5 13 16.5C12.0356 16.5 11.1997 16.1567 10.5215 15.4785C9.84332 14.8003 9.5 13.9644 9.5 13C9.5 12.0356 9.84332 11.1997 10.5215 10.5215C11.1997 9.84332 12.0356 9.5 13 9.5Z",
  fill: "#A81C1E",
  stroke: "white"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}